
      import { defu } from 'defu'
      const matcher = (m,p)=>{return [];}
      export default (path) => defu({}, ...matcher('', typeof path === 'string' ? path.toLowerCase() : path).map(r => r.data).reverse())
      